// TEMPORARY ENV CONFIG FILE
// Swap this file as needed for different environments (develop/production)
// This is the PRODUCTION config. Replace with .env.production values as needed.

export const envConfig = {
  FIREBASE_API_KEY: 'AIzaSyChh3AQ4HYuDSRPmEO-fhppwljAeeg_j7A',
  FIREBASE_AUTH_DOMAIN: 'omnichannel-3b80d1cf.firebaseapp.com',
  FIREBASE_DATABASE_URL: 'https://omnichannel-3b80d1cf.firebaseio.com',
  FIREBASE_PROJECT_ID: 'omnichannel-3b80d1cf',
  FIREBASE_STORAGE_BUCKET: 'gcf-sources-170426517486-us-central1',
  FIREBASE_MESSAGING_SENDER_ID: '170426517486',
  FIREBASE_APP_ID: '1:170426517486:web:25482bfda1bb0f6cd130ff',
  FIREBASE_MEASUREMENT_ID: '',
  ALLOWED_ORIGINS: 'https://livehost.pfizer.com,https://interactive.digitalpfizer.com,https://webfiles.digitalpfizer.com',
};
